import { combineReducers } from "redux"
import customizer from "app/redux/reducers/@customizer/customizer"

const customizerReducer = combineReducers({
  customizer
})

export default customizerReducer
